﻿import Focus from "./focusfield";

export class KeyboardFocusBounds {
  public static wireupDocument() {
    $(document).on('focus', '[data-keyboard-focus-bound]', function () {
      let $guard = $(this);
      let $parent = $guard.parent();
      if ($guard == $parent.find('[data-keyboard-focus-bound]').first())
        Focus.focusLastElement($parent);
      else
        Focus.focusFirstElement($parent);
    });
  }
}

export default KeyboardFocusBounds;